import MeditocHelper from "../../../utils/MeditocHelper";

export default function InformacionBotones() {
    return (
        <MeditocHelper title="Información de botones:">
            <div>
                <span className="bold">Iniciar consulta:</span>
            </div>
            <div>
                <ul>
                    <li>
                        Inicia la consulta del paciente conectado en el chat, llamada o videollamada. Podrá acceder a la
                        consulta y el historial clínico del paciente.
                    </li>
                    <li>
                        Las consultas NO inician automáticamente al conectarse el paciente. Confirme con su paciente
                        antes de iniciar la consulta.
                    </li>
                </ul>
            </div>
            <div>
                <span className="bold">Finalizar consulta:</span>
            </div>
            <div>
                <ul>
                    <li>
                        Finaliza la consulta del paciente. El diagnóstico y tratamiento será guardado en el historial
                        clínico del paciente.
                    </li>
                    <li>Para orientaciones únicas, el folio del paciente quedará inhabilitado.</li>
                </ul>
            </div>
            <div>
                <span className="bold">Reiniciar Chat:</span>
            </div>
            <div>
                <ul>
                    <li>
                        Reinicie el chat cuando no le sea posible atender al paciente y necesite expulsarlo de la sala.
                    </li>
                    <li>IMPORTANTE: No es posible reiniciar el chat cuando ha iniciado la consulta.</li>
                </ul>
            </div>
        </MeditocHelper>
    );
}
